import React from 'react'
import { Alert } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { deleteGedcomFile } from '@fs/zion-controlled-edit-trees'
import { useEvent } from '@fs/zion-frontend-friends'
import { useAllTreeGroups } from '../../cets/AllTreeGroupsProvider'
import { type GedcomFileFailed } from '../../../../services/gedcomTypes'

type Props = {
  fileName: string
  fileStatus: GedcomFileFailed['fileStatus']
}

export default function CetUploadError({ fileName, fileStatus }: Props): JSX.Element {
  const [t] = useTranslation()
  const { refetchFiles } = useAllTreeGroups()

  const handleDismiss = useEvent(() => {
    deleteGedcomFile(fileName).then(refetchFiles).catch(console.error)
  })

  const errorText =
    fileStatus === 'FAILED_PROCESSING'
      ? t('group-management.processing-failed-try-again.label', { fileName })
      : t('tree-import.upload-trees.error.failed_upload_error', { fileName })

  return (
    <Alert dismissable outlined type="error" onDismiss={handleDismiss}>
      {errorText}
    </Alert>
  )
}
